import { useEffect, useState, useRef, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Container, Row, Col, Button, Stack, Form, InputGroup, Alert, Spinner } from "react-bootstrap";
import LoggedInContainer from "../../layout/LoggedInContainer";
import { getFeedPerDecksForConsignment, setFeedPerDecksDB, getAllDetailedObservationsConsignmentID, getLoadedFeedOfConsignment, getDeckRecordsForConsignmentDay } from "../../api/apiAccess";
import { sortArrayInStandardDeckOrder } from "../../utils/ListUtils";
import '../../css/deckrecords.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { UserContext } from "../..";
import ReadWriteButton from "../../components/ReadWriteElements/ReadWriteButton";
import ReadWriteFormCheck from "../../components/ReadWriteElements/ReadWriteFormCheck";
import { isReportEditable } from "../../utils/common";
import { FeedPerDeck } from "../../classes/FeedPerDeck";
import ReadWriteInputGroup from "../../components/ReadWriteElements/ReadWriteInputGroup";
import ReadWriteFormControl from "../../components/ReadWriteElements/ReadWriteFormControl";
import { FeedNumberValidationRules, parseNumericInput, AnimalNumberValidationRules } from "../../utils/InputValidator";
import { DetailedDeckRecord } from "../../classes/DetailedDeckRecord";
import { StringIsNullUndefinedOrEmpty } from "../../utils/StringUtils";

// See comment in DeckRecord.js in the classes folder in regards to empty decks
const EdiFeedPerDeck = () => {
    let { state } = useLocation();
    const inputFormContainer = useRef();
    const navigate = useNavigate();
    const userCtx = useContext(UserContext);

    const [isLoading, setIsLoading] = useState(true);
    const [hasData, setHasData] = useState(false);
    const [detailedDeckRecords, setDetailedDeckRecords] = useState([]);
    const [todaysRecords, setTodaysRecords] = useState([]);
    const [yesterdayRecords, setYesterdayRecords] = useState([]);
    const [observations, setObservations] = useState([]);
    const [loadedFeed, setLoadedFeed] = useState([]);
    const [speciesList, setSpeciesList] = useState([]);
    const [hasSaveError, setHasSaveError] = useState(false);
    const [hasLoadError, setHasLoadError] = useState(false);

    const groupByDecks = (detailedDeckRecords) => {
        let lGrouped = [];

        detailedDeckRecords.forEach(dr => {
            let lGroup = lGrouped.find(gr => gr.deckID === dr.ConsignmentDeck.id)
            if (!lGroup) {
                let lNewDeck = { deckID: dr.ConsignmentDeck.id, name: dr.ConsignmentDeck.deckName, isBridge: dr.ConsignmentDeck.isBridge, detailedDeckRecords: [] }
                lGroup = lNewDeck;
                lGrouped.push(lNewDeck);
            }
            // on load data should be valid
            dr.NoHeadValid = true;
            dr.PelletsValid = true;
            dr.RoughageValid = true;
            lGroup.detailedDeckRecords.push(dr);
        })

        // sort decks
        lGrouped = sortArrayInStandardDeckOrder(lGrouped, "name", "isBridge");

        return lGrouped;
    };

    useEffect(() => {
        const fetchPageData = async () => {
            let lPromises = [
                getFeedPerDecksForConsignment(state.consignmentDay.consignmentId),
                getAllDetailedObservationsConsignmentID(state.consignmentDay.consignmentId),
                getLoadedFeedOfConsignment(state.consignmentDay.consignmentId),
                getDeckRecordsForConsignmentDay(state.consignmentDay.id)
            ];

            Promise.all(lPromises)
                .then(response => {
                    if (response && response.every(resp => resp.status === 200)) {
                        let detailedDeckRecords = [];
                        response[3].data.forEach(d => {
                            detailedDeckRecords.push(new DetailedDeckRecord(d));
                        })
                        setDetailedDeckRecords(detailedDeckRecords);

                        let todayDeckRecords = [];
                        let yesterdayRecords = []

                        response[0].data.filter(f => f.consignmentDay.id === state.consignmentDay.id).forEach(d => {
                            todayDeckRecords.push(new FeedPerDeck(d));
                        })

                        response[0].data.filter(f => f.consignmentDay.dayNumber === (state.consignmentDay.dayNumber - 1)).forEach(d => {
                            yesterdayRecords.push(new FeedPerDeck(d));
                        })

                        setObservations(response[1].data)
                        setLoadedFeed(response[2].data)

                        let todayRecord = groupByDecks(todayDeckRecords);

                        setTodaysRecords(todayRecord);
                        setYesterdayRecords(yesterdayRecords);

                        console.log("zzz", state.consignmentDay, todayRecord, response[2].data, response[3].data)

                        const seen = new Set();
                        const speciesList = detailedDeckRecords
                            .map(item => item.Species)
                            .filter(species => {
                                if (seen.has(species.id)) return false;
                                seen.add(species.id);
                                return true;
                            });

                        setSpeciesList(speciesList);

                        return true;
                    }
                    else {
                        return false;
                    }
                }).then(result => {
                    setHasData(result);
                    setHasLoadError(!result)
                    setIsLoading(false);
                })
                .catch(error => {
                    setHasLoadError(true);
                    setIsLoading(false);
                })
        }

        fetchPageData();
    }, []);

    const goBack = () => {
        navigate(`/viewfeedperdeckhistory/${state.consignmentDay.consignmentId}`, { state: { selectedColumnIndex: state?.selectedColumnIndex, editable: isReportEditable(userCtx, state.allowEditing) } })
    };

    const isNotNullOrEmpty = (value) => {
        return !StringIsNullUndefinedOrEmpty(value);
    };

    const IsValid = () => {
        let isValid = true;
        let validatedRecords = JSON.parse(JSON.stringify(todaysRecords));

        for (const deck of validatedRecords) {
            if (!isDeckEmpty(deck.deckID)) { // EMpty decks are valid
                for (const record of deck.detailedDeckRecords) {
                    const isNoHeadValid = isNotNullOrEmpty(record.NumberOfHead);
                    record.NoHeadValid = isNoHeadValid;

                    const isPelletsValid = isNotNullOrEmpty(record.Pellets);
                    record.PelletsValid = isPelletsValid;

                    const isRoughageValid = isNotNullOrEmpty(record.Roughage);
                    record.RoughageValid = isRoughageValid;

                    if (!isNoHeadValid || !isPelletsValid || !isRoughageValid) {
                        isValid = false
                    }
                }
            }
        }

        setTodaysRecords(validatedRecords);
        return isValid;
    };

    const writeToDB = async () => {
        const isValid = IsValid();

        if (1 === 1) {
            let lRecordsToSave = [];

            for (const deck of todaysRecords) {
                for (const record of deck.detailedDeckRecords) {
                    lRecordsToSave.push({
                        id: record.id,
                        FeedDetailID: record.FeedDetailID,
                        Pellets: record.Pellets,
                        Roughage: record.Roughage,
                        NumberOfHead: record.NumberOfHead,
                        IsManualWatering: record.IsManualWatering,
                    });
                }
            }
            
            let result = await setFeedPerDecksDB(lRecordsToSave);
            
            if (result.status === 200) {
                navigate(`/viewfeedperdeckhistory/${state.consignmentDay.consignmentId}`, { state: { selectedColumnIndex: state?.selectedColumnIndex, editable: isReportEditable(userCtx, state.allowEditing) } })
            }
            else {
                setHasSaveError(true);
            }
        }

    };

    const sumForSpecies = (data, targetSpeciesId) => {
        let result = {
            pellets: 0,
            roughage: 0,
            numberOfHead: 0,
            feedPerHead: 0
        };

        data.forEach(deck => {
            deck.detailedDeckRecords.forEach(record => {
                if (record.Species.id === targetSpeciesId) {
                    result.pellets += Number(record.Pellets);
                    result.roughage += Number(record.Roughage);
                    result.numberOfHead += Number(record.NumberOfHead);
                }
            });
        });

        result.feedPerHead = result.numberOfHead > 0 ? (1000 * (result.pellets + result.roughage) / result.numberOfHead).toFixed(2) : 0;

        return result;
    };

    const sumForAllDeck = (data) => {
        let result = {
            pellets: 0,
            roughage: 0,
            numberOfHead: 0,
            feedPerHead: 0
        };

        data.forEach(deck => {
            deck.detailedDeckRecords.forEach(record => {
                result.pellets += Number(record.Pellets);
                result.roughage += Number(record.Roughage);
                result.numberOfHead += Number(record.NumberOfHead);
            });
        });

        result.feedPerHead = result.numberOfHead > 0 ? (1000 * (result.pellets + result.roughage) / result.numberOfHead).toFixed(2) : 0;

        return result;
    };

    const getYesterdayFeedPerHead = (ConsignmentDeckID = undefined, speciesID = undefined) => {
        if (yesterdayRecords.length > 0) {
            let records = ConsignmentDeckID !== undefined ? yesterdayRecords.filter(record => record.ConsignmentDeck.id === ConsignmentDeckID) : yesterdayRecords;
            records = speciesID !== undefined ? records.filter(record => record.Species.id === speciesID) : records;

            if (records) {
                return (1000 * (records.reduce((sum, item) => sum + (Number(item.Pellets) || 0), 0) + records.reduce((sum, item) => sum + (Number(item.Roughage) || 0), 0)) / records.reduce((sum, item) => sum + (Number(item.NumberOfHead) || 0), 0)).toFixed(2);
            }
        }
        return "-";
    };

    const getObsROB = (observations, loadedFeed) => {
        const todayObs = observations.find(obs => obs.day.dayNumber === state.consignmentDay.dayNumber);
        const yesterdayObs = observations.find(obs => obs.day.dayNumber === (state.consignmentDay.dayNumber - 1));

        let result = {
            pellets: 0,
            roughage: 0
        }

        if (todayObs && yesterdayObs) {
            result.pellets = yesterdayObs.feedDetail.pellets - todayObs.feedDetail.pellets;
            result.roughage = yesterdayObs.feedDetail.roughage - todayObs.feedDetail.roughage;
        }
        else if (todayObs && undefined === yesterdayObs && loadedFeed) {
            result.pellets = loadedFeed.pellets - todayObs.feedDetail.pellets;
            result.roughage = loadedFeed.roughage - todayObs.feedDetail.roughage;
        }

        return result;
    };

    const isDeckEmpty = (deckID) => {
        const detaildRecord = detailedDeckRecords.find(dr => dr.ConsignmentDeck.id === deckID);
        if (detaildRecord) {
            return detaildRecord.DeckRecord.isEmpty;
        }
        else {
            return false;
        }
    };

    const updateRecord = (deckID, speciesID, field, value) => {
        if (!isDeckEmpty(deckID)) { // Can't update empty decks
            let records = [...todaysRecords]

            let deckRecord = records.find(record => record.deckID === deckID);

            if (deckRecord) {
                if (speciesID !== undefined) {
                    let record = deckRecord.detailedDeckRecords.find(record => record.Species.id === speciesID);
                    if (record) {
                        record[field] = value;
                        setTodaysRecords(records);
                    }
                } else {
                    deckRecord.detailedDeckRecords.forEach(record => {
                        record[field] = value;
                    });
                    setTodaysRecords(records);
                }
            }
        }
    };

    const setFieldValidityTrue = (deckID, speciesID, field) => {
        if (!isDeckEmpty(deckID)) { // Can't update empty decks
            let records = [...todaysRecords]

            let deckRecord = records.find(record => record.deckID === deckID);

            if (deckRecord) {
                let record = deckRecord.detailedDeckRecords.find(record => record.Species.id === speciesID);
                if (record) {
                    record[field] = true;
                    setTodaysRecords(records);
                }
            }
        }
    };

    const summary = sumForAllDeck(todaysRecords);
    const obsROB = getObsROB(observations, loadedFeed);
    const isDailyFeedMatch = summary.pellets.toFixed(2) === obsROB.pellets.toFixed(2) && summary.roughage.toFixed(2) === obsROB.roughage.toFixed(2);
    console.log("isDailyFeedMatch", summary, obsROB);

    return (
        <LoggedInContainer>
            <Container fluid className="p-0" style={{ backgroundColor: "#F5F5F5" }}>
                <Row className="upper-panel mx-0">
                    <Container>
                        <Row>
                            <Col xs={12}>
                                <div className="text-center heading-text mb-2 mt-3" style={{ color: "#FFF", paddingTop: "56px" }}>
                                    <div style={{ lineHeight: "53px", fontSize: "35px" }}>
                                        {isReportEditable(userCtx, state.allowEditing) ? "Edit Exporter Feed" : "View Exporter Feed"}
                                    </div>
                                    <div><em>Day {state.consignmentDay.dayNumber}</em></div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </Row>

                <Container ref={inputFormContainer} className="py-4 px-5 form-container-full">
                    {
                        isLoading ?
                            <Row>
                                <Col>
                                    <div className="text-center pt-5">
                                        <Spinner className="mx-auto" />
                                        <div className="mx-auto">Loading data...</div>
                                    </div>
                                </Col>
                            </Row>
                            : null
                    }
                    {hasData && isLoading === false ?
                        <Row>
                            <Col xs={12} lg={12}>
                                <Row className="align-items-end">
                                    <Col xs={1}></Col>
                                    <Col xs={10}>
                                        <Row className="align-items-end">
                                            <Col xs={2} className="dr-column-heading">
                                                <div>Species</div>
                                            </Col>
                                            <Col xs={8}>
                                                <Row className="align-items-end">
                                                    <Col xs={12} className="dr-column-heading">
                                                        <div style={{ textAlign: "center" }}>Fed today</div>
                                                    </Col>
                                                </Row>
                                                <Row className="align-items-end">
                                                    <Col xs={3} className="dr-column-heading align-bottom">
                                                        <div>No. of Head</div>
                                                    </Col>
                                                    <Col xs={3} className="dr-column-heading align-bottom">
                                                        <div>Pellets</div>
                                                    </Col>
                                                    <Col xs={3} className="dr-column-heading align-bottom">
                                                        <div>Roughage</div>
                                                    </Col>
                                                    <Col xs={3} className="dr-column-heading align-bottom">
                                                        <div>Feed per head</div>
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col xs={2} className="dr-column-heading">
                                                <div>Yesterday's<br /> feed per head</div>
                                            </Col>

                                        </Row>
                                    </Col>
                                    <Col xs={1} className="dr-column-heading">
                                        <div>Watering</div>
                                    </Col>
                                </Row>
                                {
                                    todaysRecords.map((deck, deckIndex) => {
                                        const deckEmpty = isDeckEmpty(deck.deckID);
                                        return (
                                            <Row key={`deck${deck.deckID}`} className={`pb-3 pt-3 gray-border-top`} >
                                                <Col xs={1} className="dr-text">
                                                    {deck.name}
                                                </Col>
                                                <Col xs={10}>
                                                    {deck.detailedDeckRecords.map((feedPerDeck) =>
                                                        <Row key={`feedPerDeck_${feedPerDeck.id}`} className="align-items-end">
                                                            <Col xs={2} className="dr-column-heading">
                                                                <div>{feedPerDeck.Species.speciesName}</div>
                                                            </Col>
                                                            <Col xs={8}>
                                                                <Row className="align-items-end">
                                                                    <Col xs={3} className="dr-column-heading align-bottom">
                                                                        <ReadWriteFormControl
                                                                            className="text-13-400 secondary-grey errorLeft"
                                                                            style={{ textAlign: "right" }}
                                                                            value={deckEmpty ? "-" : feedPerDeck.NumberOfHead}
                                                                            onChange={(e) => {
                                                                                e.preventDefault();
                                                                                parseNumericInput(e, new AnimalNumberValidationRules());
                                                                                updateRecord(deck.deckID, feedPerDeck.Species.id, 'NumberOfHead', e.target.value);
                                                                                setFieldValidityTrue(deck.deckID, feedPerDeck.Species.id, "NoHeadValid");
                                                                            }}
                                                                            disabled={deckEmpty}
                                                                            isInvalid={!feedPerDeck.NoHeadValid}
                                                                        />
                                                                    </Col>
                                                                    <Col xs={3} className="dr-column-heading align-bottom">
                                                                        <Form.Group>
                                                                            <ReadWriteInputGroup readonlyclasses="text-13-400 secondary-grey">
                                                                                <Form.Control
                                                                                    value={deckEmpty ? "-" : feedPerDeck.Pellets}
                                                                                    onChange={(e) => {
                                                                                        e.preventDefault();
                                                                                        parseNumericInput(e, new FeedNumberValidationRules());
                                                                                        updateRecord(deck.deckID, feedPerDeck.Species.id, 'Pellets', e.target.value);
                                                                                        setFieldValidityTrue(deck.deckID, feedPerDeck.Species.id, "PelletsValid");
                                                                                    }}
                                                                                    className="inputGroupWithAppend errorLeft"
                                                                                    disabled={deckEmpty}
                                                                                    isInvalid={!feedPerDeck.PelletsValid}
                                                                                />
                                                                                <InputGroup.Text className={`inputGroupAppend text-13-400 secondary-grey ${!feedPerDeck.PelletsValid ? "invalidAppend" : ""}`}>
                                                                                    t
                                                                                </InputGroup.Text>
                                                                            </ReadWriteInputGroup>
                                                                        </Form.Group>
                                                                    </Col>
                                                                    <Col xs={3} className="dr-column-heading align-bottom">
                                                                        <Form.Group>
                                                                            <ReadWriteInputGroup readonlyclasses="text-13-400 secondary-grey">
                                                                                <Form.Control
                                                                                    value={deckEmpty ? "-" : feedPerDeck.Roughage}
                                                                                    onChange={(e) => {
                                                                                        e.preventDefault();
                                                                                        parseNumericInput(e, new FeedNumberValidationRules());
                                                                                        updateRecord(deck.deckID, feedPerDeck.Species.id, 'Roughage', e.target.value);
                                                                                        setFieldValidityTrue(deck.deckID, feedPerDeck.Species.id, "RoughageValid");
                                                                                    }}
                                                                                    className="inputGroupWithAppend errorLeft"
                                                                                    disabled={deckEmpty}
                                                                                    isInvalid={!feedPerDeck.RoughageValid}
                                                                                />
                                                                                <InputGroup.Text className={`inputGroupAppend text-13-400 secondary-grey ${!feedPerDeck.RoughageValid ? "invalidAppend" : ""}`}>
                                                                                    t
                                                                                </InputGroup.Text>
                                                                            </ReadWriteInputGroup>
                                                                        </Form.Group>
                                                                    </Col>
                                                                    <Col xs={3} className="dr-column-heading align-bottom">
                                                                        {
                                                                            deckEmpty || !feedPerDeck.NumberOfHead ?
                                                                                <div>- kg/hd</div> :
                                                                                <div>{(1000 * (Number(feedPerDeck.Pellets) + Number(feedPerDeck.Roughage)) / Number(feedPerDeck.NumberOfHead)).toFixed(2)} kg/hd</div>
                                                                        }
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                            <Col xs={2} className="dr-column-heading">
                                                                <div> {getYesterdayFeedPerHead(feedPerDeck.ConsignmentDeck.id, feedPerDeck.Species.id)} kg/hd </div>
                                                            </Col>
                                                        </Row>
                                                    )}

                                                    {
                                                        deck.detailedDeckRecords.length > 1 && (
                                                            <Row className="align-items-end">
                                                                <Col xs={2} className="dr-column-heading">
                                                                    <div> </div>
                                                                </Col>
                                                                <Col xs={8}>
                                                                    <Row className="align-items-end">
                                                                        <Col xs={3} className="dr-column-heading align-bottom">
                                                                            <div></div>
                                                                        </Col>
                                                                        <Col xs={3} className="dr-column-heading align-bottom gray-frame">
                                                                            <div>Deck: {deck.detailedDeckRecords.reduce((sum, item) => sum + (Number(item.Pellets) || 0), 0).toFixed(2)} t</div>
                                                                        </Col>
                                                                        <Col xs={3} className="dr-column-heading align-bottom gray-frame">
                                                                            <div>{deck.detailedDeckRecords.reduce((sum, item) => sum + (Number(item.Pellets) || 0), 0).toFixed(2)} t</div>
                                                                        </Col>
                                                                        <Col xs={3} className="dr-column-heading align-bottom gray-frame">
                                                                            <div>{(deck.detailedDeckRecords.reduce((sum, item) => sum + (Number(item.Pellets) || 0), 0) + deck.detailedDeckRecords.reduce((sum, item) => sum + (Number(item.Pellets) || 0), 0)).toFixed(2)} t total</div>
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                                <Col xs={2} className="dr-column-heading">
                                                                    <div> {getYesterdayFeedPerHead(deck.detailedDeckRecords[0].ConsignmentDeck.id)} kg/hd </div>
                                                                </Col>
                                                            </Row>
                                                        )
                                                    }
                                                </Col>
                                                <Col xs={1} className="dr-column-heading">
                                                    <ReadWriteFormCheck
                                                        id={`chkISisManualWatering_${deckIndex}`}
                                                        label="Manual watering"
                                                        onChange={(e) => {
                                                            updateRecord(deck.deckID, undefined, 'IsManualWatering', e.target.checked)
                                                        }}
                                                        checked={deck.detailedDeckRecords[0].IsManualWatering}
                                                        className="field-label"
                                                        disabled={deckEmpty}
                                                    />
                                                </Col>
                                            </Row>
                                        )
                                    })
                                }

                                {speciesList.map((species, index) => {
                                    const record = sumForSpecies(todaysRecords, species.id)
                                    return (
                                        <Row key={`deck-s-${species.id}`} className={index > 0 ? `pb-1 pt-1` : 'pb-1 pt-4 gray-border-top'} >
                                            <Col xs={1} className="dr-text">
                                            </Col>
                                            <Col xs={10}>
                                                <Row className="align-items-end">
                                                    <Col xs={2} className="dr-column-heading">
                                                        <div>{species.speciesName} Total</div>
                                                    </Col>
                                                    <Col xs={8}>
                                                        <Row className="align-items-end">
                                                            <Col xs={3} className="dr-column-heading align-bottom">
                                                                <div>{record.numberOfHead}</div>
                                                            </Col>
                                                            <Col xs={3} className="dr-column-heading align-bottom">
                                                                <div>{record.pellets.toFixed(2)} t</div>
                                                            </Col>
                                                            <Col xs={3} className="dr-column-heading align-bottom">
                                                                <div>{record.roughage.toFixed(2)} t</div>
                                                            </Col>
                                                            <Col xs={3} className="dr-column-heading align-bottom">
                                                                <div>{record.feedPerHead} kg/hd</div>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                    <Col xs={2} className="dr-column-heading">
                                                        <div> {getYesterdayFeedPerHead(undefined, species.id)} kg/hd </div>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>)
                                })}

                                <Row className={'pb-1 pt-4 gray-border-top'} >
                                    <Col xs={1} className="dr-text">
                                    </Col>
                                    <Col xs={10}>
                                        <Row className="align-items-end">
                                            <Col xs={4} className="dr-column-heading">
                                                <strong>
                                                    Total feed consumption
                                                </strong>
                                            </Col>
                                            <Col xs={6}>

                                            </Col>
                                            <Col xs={2} className="dr-column-heading">

                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>

                                {summary && (
                                    <Row className={`pb-1 pt-1`} >
                                        <Col xs={1} className="dr-text">
                                        </Col>
                                        <Col xs={10}>
                                            <Row className="align-items-end">
                                                <Col xs={4} className="dr-column-heading">
                                                    <div>Daily feed(Deck Records)</div>
                                                </Col>
                                                <Col xs={6}>
                                                    <Row className="align-items-end">
                                                        <Col xs={4} className="dr-column-heading align-bottom">
                                                            <div>{summary.pellets.toFixed(2)} t</div>
                                                        </Col>
                                                        <Col xs={4} className="dr-column-heading align-bottom">
                                                            <div>{summary.roughage.toFixed(2)} t</div>
                                                        </Col>
                                                        <Col xs={4} className="dr-column-heading align-bottom">
                                                            <div>{summary.feedPerHead} kg/hd</div>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col xs={2} className="dr-column-heading">
                                                    <div> {getYesterdayFeedPerHead()} kg/hd </div>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                )}

                                {obsROB && (
                                    <Row className={`pb-1 pt-1`} >
                                        <Col xs={1} className="dr-text">
                                        </Col>
                                        <Col xs={10}>
                                            <Row className="align-items-end">
                                                <Col xs={4} className="dr-column-heading">
                                                    <div>Daily feed (calculated from ROB)</div>
                                                </Col>
                                                <Col xs={4}>
                                                    <Row className="align-items-end">
                                                        <Col xs={6} className="dr-column-heading align-bottom">
                                                            <div>{obsROB.pellets.toFixed(2)} t</div>
                                                        </Col>
                                                        <Col xs={6} className="dr-column-heading align-bottom">
                                                            <div>{obsROB.roughage.toFixed(2)} t</div>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col xs={4} className={!isDailyFeedMatch ? "dr-column-heading gray-frame" : ""}>
                                                    {
                                                        !isDailyFeedMatch &&
                                                        <div>
                                                            <FontAwesomeIcon className="warn-icon" icon={faInfoCircle} title="Totals do not match" />
                                                            <span style={{ marginLeft: "5px" }}>Totals do not match</span>
                                                        </div>
                                                    }
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                )}

                            </Col>
                        </Row>
                        : null
                    }
                </Container>
                {
                    isLoading === false && hasData === true ?
                        <Row className="w-100 pt-4" style={{ position: "relative", top: "-300px" }}>
                            {
                                hasSaveError === true ?
                                    <Col xs={12}>
                                        <Container>
                                            <Row>
                                                <Col>
                                                    <Alert variant='danger'>Unable to save. Please wait a few minutes an try again. If the problem persists contact administration.</Alert>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </Col>
                                    : null
                            }

                            <Col xs={12}>
                                <Stack direction="horizontal" gap={2} style={{ justifyContent: "center" }}>
                                    <ReadWriteButton writeonly={false} readonlytext="Back" variant="secondary" onClick={() => { goBack() }} size="lg" style={{ minWidth: "150px" }}>Cancel</ReadWriteButton>
                                    {isReportEditable(userCtx, state.allowEditing) &&
                                        <ReadWriteButton writeonly={true} variant="primary" onClick={() => { writeToDB() }} size="lg" style={{ minWidth: "150px" }}>Update</ReadWriteButton>
                                    }
                                </Stack>
                            </Col>
                        </Row>
                        : null
                }
                {
                    (hasLoadError === true || hasData === false) && isLoading === false ?
                        <Container>
                            <Row>
                                <Col xs={12}>
                                    <Alert variant='danger'>Unable to load deck record.</Alert>
                                </Col>
                                <Col xs={12}>
                                    <Button className="me-2 ms-auto" variant="primary" onClick={() => { goBack() }} size="lg" style={{ minWidth: "150px" }}>Back</Button>
                                </Col>
                            </Row>
                        </Container>

                        : null
                }
            </Container >
        </LoggedInContainer >
    )
};

export default EdiFeedPerDeck;